import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";
import { Dimmer } from "../../spinner";
import { AgregarTributo } from "./modalAgregarTributo";
import { hex_md5 } from "../../../util/Md5";
import axios from "axios";
import { validaSoloNumero } from "../../../util/varios";
import useTableFijo from "../../useTableFijo";
import { Input, Select, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, SuccessButton, WarningButton } from "../../../ui/buttons/Button";

export const EditarUsuarioWeb = (props) => {
  let op = require("../../../../src/modulos/datos");
  var correo = op.email.trim();
  var cne = op.cne.trim();
  let token = localStorage.getItem("jwtToken");

  const headCells = [
    {
      id: "tributo",
      label: "TRIBUTO",
      width: "50px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "codigo",
      label: "CODIGO",
      width: "50px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombre",
      label: "NOMBRE",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "direccion",
      label: "DIRECCION",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "opcion",
      label: "OPCION",
      width: "20px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  /*  variables de estados */
  const btnAceptar = useRef();
  const btnCancela = useRef();
  const txtDireccion = useRef();
  const txtTelefono = useRef();
  const txtEmail = useRef();
  const txtEmailS = useRef();
  const txtCodigo = useRef();
  const txtCedula = useRef();
  const cmbNacionalidad = useRef();
  const txtNombre = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [titulo1, setTitulo1] = useState();
  const [msg1, setMsg1] = useState();
  const [dato, setDato] = useState([]);
  const [password, setPassword] = useState("");
  const [dataTributo, setDataTributo] = useState();
  const [activate, setActivate] = useState(false);
  const [eliminando] = useState(false);
  const [eliminandotributo] = useState(false);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [operacion, setOperacion] = useState(1);
  const [desabilittar, setDesabilitar] = useState({
    codigo: true,
    nacionalidad: false,
    cedula: false,
    nombre: false,
    telefono: false,
    direccion: false,
    email1: false,
    email2: false,
  });
  const [values, setValues] = useState({
    email2: "",
    estatus: "",
    cedula: "",
    nombre: "",
    direccion: "",
    telefono: "",
    rif: "",
    dirip: "",
    bitacora: "",
    nacionalidad: "V",
    agenteretencion: false,
    idcomercio: "",
    idusuarioweb: "",
    login: "",
    passwd: "",
  });
  const [btnDisabled, setBtnDisabled] = useState({
    editarUsuario: false,
    cambiarCorreo: false,
    cambioclave: false,
    eliminarRegistro: false,
  });
  const blanquear = () => {
    setDesabilitar({
      codigo: true,
      nacionalidad: false,
      cedula: false,
      nombre: false,
      telefono: false,
      direccion: false,
      email1: false,
      email2: false,
    });

    setValues({
      email2: "",
      estatus: "",
      cedula: "",
      nombre: "",
      direccion: "",
      telefono: "",
      rif: "",
      dirip: "",
      bitacora: "",
      nacionalidad: "V",
      agenteretencion: false,
      idcomercio: "",
      idusuarioweb: "",
      login: "",
      passwd: "",
    });

    setBtnDisabled({
      editarUsuario: false,
      cambiarCorreo: false,
      cambioclave: false,
      eliminarRegistro: false,
    });

    setMostrar(false);
    setTitulo("");
    setMsg("");
    setMostrar1(false);
    setTitulo1("");
    setMsg1("");
    setDato([]);
    setPassword("");
    setActivate(false);
  };

  const onChange = (event) => {
    if (event.target.name === "direccion") {
      event.target.value = event.target.value.toUpperCase();
    }

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const { TblContainer, TblHead } = useTableFijo(
    props.tributos,
    headCells,
    filterFn,
    320
  );

  const validarUsuario = () => {
    if (txtCedula.current.value !== "") {
      let campos = "*";
      let nomtab = "persona";
      let nomid = "cedula";
      let endpoint = `${
        op.conexion
      }/api/consulta/modeli?campos=${campos}&id=${parseInt(
        txtCedula.current.value
      )}&nomtab=${nomtab}&nomid=${nomid}`;
      setActivate(true);
      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            if (response.data !== "") {
              setValues({
                ...values,
                nombre:
                  response.data.nombres.trim() +
                  " " +
                  response.data.apellidos.trim(),
                cedula: txtCedula.current.value.trim(),
              });
              txtTelefono.current.value = response.data.tlf1;
              txtDireccion.current.value = response.data.direccion;
            } else {
              setValues({ ...values, nombre: "" });
              let endpoint =
                cne +
                "/cne?nac=" +
                cmbNacionalidad.current.value +
                "&ced=" +
                txtCedula.current.value;
              axios
                .get(endpoint)
                .then(function (response) {
                  if (response.status == 200) {
                    setActivate(false);
                    switch (response.data.cedula) {
                      case "error de conexion al cne":
                        setTitulo("notificación");
                        setMsg("Error interno de Conexión");
                        setMostrar(true);
                        break;
                      case "los datos son incorrectos":
                        setTitulo("notificación");
                        setMsg("los datos son incorrectos");
                        setMostrar(true);
                        break;
                      case "Esta cedula de identidad no se encuentra":
                        setTitulo("notificación");
                        setMsg("La cédula no existe.");
                        setMostrar(true);
                        break;
                      case "FALLECIDO":
                        setTitulo("notificación");
                        setMsg("FALLECIDO");
                        setMostrar(true);
                        break;
                      default:
                        setValues({
                          ...values,
                          nombre: response.data.cedula,
                          cedula: txtCedula.current.value.trim(),
                        });
                        break;
                    }
                  }
                })
                .catch(function (err) {
                  if (err) {
                    setTitulo("notificación");
                    setMsg("Error interno de Conexión");
                    setMostrar(true);
                  }
                })
                .finally(function () {
                  setActivate(false);
                });
            }

            setActivate(false);
          }
        })
        .catch((error) => {
          setTitulo("ERROR");
          setMsg(error.response.data.message);
          setMostrar(true);
          setActivate(false);
        });
    } else {
      setTitulo("notificación");
      setMsg("Introduzca su número de cédula.");
      setMostrar(true);
    }
  };

  const handleInputChange = (event) => {
    if (event.target.name === "login" || event.target.name === "email2") {
      event.target.value = event.target.value.toLowerCase();
    }

    if (event.which === 13 && props.operacion === 2) {
      if (event.target.name === "login") {
        actualizarUsuario();
      } else if (event.target.name === "email2") {
        actualizarUsuario();
      }
    }
  };

  const validarNumber = (event) => {
    validaSoloNumero(event);
    if (event.which === 13) {
      if (event.target.name === "txtCedula") {
        validarUsuario();
      }
    }
    if (event.target.name === "telefono") {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };

  const validar = () => {
    let sigue = true;
    if (operacion === 1) {
      if (msg === "FALLECIDO") {
        setTitulo("notificación");
        setMsg("No se puede registrar un usuario fallecido.");
        setMostrar(true);
      } else {
        if (values.cedula === "") {
          sigue = false;
          setTitulo("notificación");
          setMsg("Ingrese Un N° de Cedula Valido.");
          setMostrar(true);
        } else if (values.nombre === "") {
          sigue = false;
          setTitulo("notificación");
          setMsg("Ingrese el Nombre del Usuario.");
          setMostrar(true);
        } else if (values.telefono === "") {
          sigue = false;
          setTitulo("notificación");
          setMsg("Ingrese el N° de Telefono del Usuario.");
          setMostrar(true);
        } else if (values.direccion === "") {
          sigue = false;
          setTitulo("notificación");
          setMsg("Ingrese la Dirección del Usuario.");
          setMostrar(true);
        } else if (values.login === "") {
          setTitulo("notificación");
          setMsg("Introduzca un E-mail Valido.");
          setMostrar(true);
        } else if (values.email2 === "") {
          setTitulo("notificación");
          setMsg("Introduzca un E-mail Secundario Valido.");
          setMostrar(true);
        } else if (values.login.indexOf("@") == -1) {
          setTitulo("notificación");
          setMsg("el E-mail debe tener un formato valido.");
          setMostrar(true);
        } else if (values.email2.indexOf("@") == -1) {
          setTitulo("notificación");
          setMsg("el E-mail debe tener un formato valido.");
          setMostrar(true);
        } else if (sigue) {
          actualizarUsuario();
        }
      }
    } else {
      actualizarUsuario();
    }
  };

  const handleCloseSi = () => {
    setMostrar1(false);
    if (msg1 === "esta seguro de cambiar el correo?") {
      setActivate(true);
    } else if (msg1 === "esta seguro de eliminar el registro?") {
      actualizarUsuario();
      setMostrar1(false);
    } else if (msg1 === "esta seguro de eliminar el tributo?") {
      deleteTributo();
      setMostrar1(false);
    } else if (msg1 === "esta seguro de cambiar contraseña?") {
      actualizarUsuario();
      setMostrar1(false);
    }
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
    if (
      msg === "correo cambiado exitosamente!" ||
      msg === "registro creado correctamente." ||
      msg === "registro eliminado correctamente." ||
      msg === "registro modificado correctamente." ||
      titulo === "contraseña cambiada exitosamente!" ||
      msg === "registro eliminado exitosamente!"
    ) {
      cancelar();
      props.onHideRenderizar();
      props.onHideCancela();
      props.renderizar();
      blanquear();
    } else if (msg === "tributo eliminado exitosamente!") {
      renderizar();
      blanquear();
      props.onHideCancela();
      props.renderizar();
      blanquear();
    }
  };

  const generar = (longitud) => {
    var long = parseInt(longitud);
    var caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ2346789";
    var contraseña = "";
    for (var i = 0; i < long; i++)
      contraseña += caracteres.charAt(
        Math.floor(Math.random() * caracteres.length)
      );
    return contraseña;
  };

  useEffect(() => {
    setPassword(generar(6).toString());
  }, []);

  var pass2 = hex_md5(password);

  const CambiarCorreo = () => {
    setOperacion(3);
    setDesabilitar({ ...desabilittar, email1: false, email2: false });
    setBtnDisabled({
      ...btnDisabled,
      editarUsuario: true,
      cambioclave: true,
      eliminarRegistro: true,
    });
    txtEmail.current.focus();
  };

  const actualizarUsuario = () => {
    let endpoint = `${op.conexion}/api/industria/agregarusuarioweb`;
    let body;
    setActivate(true);

    body = {
      operacion: parseInt(operacion),
      iduser: values.codigo !== "" ? parseInt(txtCodigo.current.value) : 0,
      correo1: txtEmail.current.value.trim(),
      pass: pass2,
      idcomer: 0,
      correo2: txtEmailS.current.value.trim(),
      ced: parseInt(txtCedula.current.value.trim()),
      nom: txtNombre.current.value.trim(),
      direc: txtDireccion.current.value.trim(),
      tlf: txtTelefono.current.value.trim(),
      naci: cmbNacionalidad.current.value.trim(),
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setTitulo("Notificacion");
            setMsg("registro creado correctamente.");
            setMostrar(true);
          } else if (operacion === 5) {
            setTitulo("Notificacion");
            setMsg("registro eliminado correctamente.");
            setMostrar(true);
          } else {
            setTitulo("Notificacion");
            setMsg("registro modificado correctamente.");
            setMostrar(true);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });

    setActivate(true);
  };

  const editarUsuario = () => {
    setOperacion(2);
    txtCedula.current.focus();
    setDesabilitar({
      ...desabilittar,
      codigo: true,
      nacionalidad: false,
      cedula: false,
      nombre: false,
      telefono: false,
      direccion: false,
    });
    setBtnDisabled({
      ...btnDisabled,
      cambiarCorreo: true,
      cambioclave: true,
      eliminarRegistro: true,
    });
  };

  const CambiarContrasena = () => {
    setTitulo1("Notificación");
    setMsg1("esta seguro de cambiar contraseña?");
    setActivate(true);
  };

  const eliminarUsuario = () => {
    setOperacion(5);
    setMostrar1(true);
    setTitulo1("Notificación");
    setMsg1("esta seguro de eliminar el registro?");
  };

  const elimTri = (data) => (event) => {
    event.preventDefault();
    setDataTributo(data);
    setMostrar1(true);
    setTitulo1("Notificación");
    setMsg1("esta seguro de eliminar el tributo?");
  };

  const deleteTributo = () => {
    let endpoint = `${op.conexion}/api/industria/agregartributo`;
    let body = {
      operacion: 3,
      iduser: parseInt(values.idusuarioweb),
      trib: dataTributo.tributo,
      idtrib: parseInt(dataTributo.idtributo),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          props.onHideRenderizarTributos(values.idusuarioweb);
          setActivate(false);
          setTitulo("NOTIFICACION");
          setMsg("Tributo eliminado con exito!.");
          setMostrar(true);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const incluirTributo = () => {
    setMostrar2(true);
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const renderizar = () => {
    props.onHideRenderizarTributos(values.idusuarioweb);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        btnCancela.current.focus();
        if (props.operacion !== 1) {
          setValues(props.usuario);
          setDesabilitar({
            codigo: true,
            nacionalidad: true,
            cedula: true,
            nombre: true,
            telefono: true,
            direccion: true,
            email1: true,
            email2: true,
          });
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 azulGradiant text-light">
        <h3 className = 'fw-bold m-0'>
          Gestionar Usuario Web
        </h3>
        <a type = 'button'
          ref={btnCancela}
          className = 'fw-bold text-light fs-6'
          onClick={cancelar}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 m-0 p-0">
          <ul className="nav mb-2" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios"
                data-bs-toggle="tab"
                data-bs-target="#tributarios"
                type="button"
                role="tab"
                aria-controls="tributarios"
                aria-selected="true"
              >
                Datos del Usuario
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-200 text-light"
                disabled={props.operacion === 1 ? true : false}
                id="deuda-tab"
                data-bs-toggle="tab"
                data-bs-target="#deuda"
                type="button"
                role="tab"
                aria-controls="deuda"
                aria-selected="false"
              >
                Tributos
              </a>
            </li>
          </ul>
          <div className="tab-content m-0 p-0" id="myTabContent">
            <div className="tab-pane fade show active m-0"
              id="tributarios"
              role="tabpanel"
              aria-labelledby="datosTributarios"
            >
              <div className = 'col-12 m-0 p-0 d-flex flex-wrap'>
                <div className="col-4 col-lg-3 m-0 mb-2 p-0">
                  <Input label = 'Código:'
                    defaultValue={values.idusuarioweb}
                    ref={txtCodigo}
                    id="validationTooltip01"
                    disabled={desabilittar.codigo}
                  />
                </div>
                <div className="col-6 col-lg-4 m-0 mb-2 p-0 pl-2 d-flex">
                  <Select label = 'Cédula:'
                    name="cmbNacionalidad"
                    id="inputCedula"
                    defaultValue={values.nacionalidad}
                    disabled={desabilittar.nacionalidad}
                    ref={cmbNacionalidad}
                  >
                    <option value="V">V</option>
                    <option value="E">E</option>
                  </Select>
                  <Input
                    defaultValue={values.cedula}
                    ref={txtCedula}
                    name="txtCedula"
                    min={0}
                    maxLength={9}
                    id="txtCedula"
                    disabled={desabilittar.cedula}
                    onKeyUp={validarNumber}
                    onFocus={validarNumber}
                    onChange={validarNumber}
                  />
                </div>
                <div className="col-6 col-lg-4 m-0 mb-2 p-0 pl-lg-2">
                  <Input label = 'Telefono:'
                    name="telefono"
                    ref={txtTelefono}
                    defaultValue={values.telefono}
                    placeholder="ingrese su telefono"
                    id="txtTelefono"
                    maxLength={11}
                    disabled={desabilittar.telefono}
                    onKeyUp={validarNumber}
                    onChange={validarNumber}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input label = 'Nombre:'
                    name="txtNombre"
                    defaultValue={values.nombre}
                    id="txtNombre"
                    ref={txtNombre}
                    disabled={desabilittar.nombre}
                  />
                </div>
                <div className="col-12 m-0 p-0">
                  <Textarea label = 'Dirección:'
                    style={{ height: 70 }}
                    placeholder="ingrese su direccion"
                    name="direccion"
                    ref={txtDireccion}
                    defaultValue={values.direccion}
                    disabled={desabilittar.direccion}
                    onChange={onChange}
                  />
                </div>
                <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
                  <legend className="float-none w-auto m-0">Datos del Registro Web</legend>
                    <div className="col-12 col-lg-6 m-0 mb-2 mb-lg-0 p-0">
                        <Input label = 'E-mail:'
                            name="login"
                            ref={txtEmail}
                            autoComplete="off"
                            defaultValue={values.login}
                            onKeyUp={handleInputChange}
                            onChange={onChange}
                            type="email"
                            id="txtEmail"
                            disabled={desabilittar.email1}
                        />
                    </div>
                    <div className="col-12 col-lg-6 m-0 p-0 pl-lg-2">
                        <Input label = 'E-mail Secundario:'
                            name="email2"
                            ref={txtEmailS}
                            autoComplete="off"
                            defaultValue={values.email2}
                            onKeyUp={handleInputChange}
                            onChange={onChange}
                            type="email"
                            id="txtEmailS"
                            disabled={desabilittar.email2}
                        />
                    </div>
                </fieldset>
                {props.operacion === 2 &&
                  <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex gap-2">
                    <legend className="float-none w-auto m-0"> Opciones</legend>
                    <div className="col m-0 p-0">
                      <WarningButton icon = 'fa-edit'
                        onClick={editarUsuario}
                        disabled={btnDisabled.editarUsuario}
                      >
                          Editar Usuario
                      </WarningButton>
                    </div>
                    <div className="col m-0 p-0">
                      <WarningButton icon = 'fa-edit'
                        onClick={CambiarCorreo}
                        disabled={btnDisabled.cambiarCorreo}
                      >
                          Cambiar Correo
                      </WarningButton>
                    </div>
                    <div className="col m-0 p-0">
                      <WarningButton icon = 'fa-edit'
                        onClick={CambiarContrasena}
                        disabled={btnDisabled.cambioclave}
                      >
                          Cambiar Clave
                      </WarningButton>
                    </div>
                    <div className="col m-0 p-0">
                      <DangerButton icon = 'fa-trash-alt'
                        onClick={eliminarUsuario}
                        disabled={btnDisabled.eliminarRegistro}
                      >
                          Eliminar Registro
                      </DangerButton>
                    </div>
                  </fieldset>
                }
                </div>
              </div>
            <div
              className="tab-pane fade "
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              {/* TODO - NO HAY PERMISOS PARA HACER ESTO */}
              <div className="row col-md-12 mx-auto px-1 mt-2">
                <fieldset className=" row col-md-12 border-azul rounded mx-auto">
                  <legend className="float-none w-auto">
                    {" "}
                    Tributos Asociados a este Usuario
                  </legend>

                  <div className="col-md-12 col-xs-12 d-flex justify-content-end">
                    <button
                      className="btn btn-sm btn-primary rounded-circle"
                      onClick={incluirTributo}
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                  </div>

                  <TblContainer
                    container={{
                      height: 250,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead />

                    <tbody>
                      {props.tributos &&
                        props.tributos.map((item, index) =>
                          item.idtributo === "" ? (
                            ""
                          ) : (
                            <tr
                              key={
                                item.periodo +
                                item.numfactura +
                                item.numdocumento
                              }
                              style={{ padding: "0" }}
                            >
                              <td style={{ textAlign: "center" }}>
                                {item.tributo}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.idtributo}
                              </td>
                              <td style={{ textAlign: "left", width: "50px" }}>
                                {item.nombre}
                              </td>
                              <td style={{ textAlign: "left", width: "50px" }}>
                                {item.direccion}
                              </td>
                              <td
                                style={{ textAlign: "center", width: "20px" }}
                              >
                                <button
                                  onClick={elimTri(item)}
                                  className="btn btn-sm btn-danger rounded-circle"
                                >
                                  <i className="fa fa-trash-alt"></i>
                                </button>
                              </td>
                            </tr>
                          )
                        )}
                    </tbody>
                  </TblContainer>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAceptar}
          onClick={validar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <AgregarTributo
          show={mostrar2}
          onHideCancela={handleCancela2}
          idusuarioweb={values.idusuarioweb}
          onHideRenderizar={renderizar}
          onHideRenderizarTributos={props.onHideRenderizarTributos}
        />

        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <MensajeSiNo
          titulo={titulo1}
          mensaje={msg1}
          show={mostrar1}
          onHideNo={handleCloseNo}
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted></Dimmer>
        {eliminando == true && <Dimmer active={true} inverted></Dimmer>}
        {eliminandotributo == true && <Dimmer active={true} inverted></Dimmer>}
    </Modal>
  );
};
